export default "__VITE_ASSET__C5DQQ6xg__"